
import { defineComponent } from "vue";

import Dialog from "primevue/dialog";
import MapCustom from "@/components/MapCustom.vue";
import { Coordinates, Marker } from "@/typings/Marker";
import { QueryParameters } from "@/typings/QueryParameters";
import { Event } from "@/typings/Event";

export default defineComponent({
  data: () => ({
    showMap: false,
    center: { lat: 45.91831, lng: 14.229618 } as Coordinates,
    zoom: 15,
    markers: [] as Marker[],
  }),
  methods: {
    openMap() {
      this.loadEvents();
      this.showMap = true;
    },
    closeMap() {
      this.showMap = false;
    },
    updateCenter(value: Coordinates) {
      this.center = value;
      this.loadEvents();
    },
    updateZoom(value: number) {
      this.zoom = value;
      this.loadEvents();
    },
    loadEvents() {
      let params: QueryParameters & {
        latitude?: number;
        longitude?: number;
        radius?: number;
      } = {
        latitude: this.center.lat,
        longitude: this.center.lng,
        radius: Math.pow(2, 27 - this.zoom),
      };

      this.$http.get("api/v1/events", { params }).then((response) => {
        let eventArray = response.data.data as Event[];
        this.markers = eventArray.map((event) => ({
          id: event.id,
          position: {
            lat: parseFloat(event.latitude),
            lng: parseFloat(event.longitude),
          },
          on_click_route_name: "Event",
          type: "event",
        }));
      });
    },
  },
  components: { MapCustom, Dialog },
});
